export function isTesting() {
  return false
  // return import.meta.env.MODE !== 'production'
}

export function isBetaFeatureEnabled() {
  return true
  // return import.meta.env.MODE !== 'betaFeatures'
}

// TODO: Implement env variables
